import {observer} from "mobx-react";
import {Component} from "preact";
import {OccupancyResponse} from "../model";
import {gracePeriodModel} from "../model/gracePeriod";
import {resources} from "../resources";
import {Icon} from "./controls/Icon";
import style from "./GracePeriodCountDown.module.css";

export const GracePeriodCountDown = observer(
	class GracePeriodCountDown extends Component<{ occupancy: OccupancyResponse }> {
		render() {
			const {occupancy} = this.props;
			const secondsLeft = gracePeriodModel.getGracePeriodSecondsLeft(occupancy.id);
			if (secondsLeft) {
				const timeLeft = "" + ((secondsLeft / 60) | 0) + ":" + ("00" + (secondsLeft % 60)).slice(-2);

				return (
					<div class={style.gracePeriodCountDown}>
						<div class={style.icon}>
							<div class={style.hourglassIcon}>
								<Icon>hourglass_empty</Icon>
							</div>
							<div class={style.scheduleIcon}>
								<Icon>schedule</Icon>
							</div>
						</div>
						<div class={style.textRight}>
							<div class={style.onlyText}>
								{resources.strings.GracePeriodOnly}
							</div>
							<div class={style.timeLeft}>
								{timeLeft}
							</div>
						</div>
						<div class={style.textBottom}>
							{resources.strings.GracePeriodMinutesLeftToOpen}
						</div>
					</div>
				);
			}
			else {
				return null;
			}
		}
	},
);
